import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTeamCollabs, setTeamsCollabs } from "../../components/clients/clientsSlice";
import { editCollabMission, getCollabMissions } from "../../components/teams/teamsSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Langs, { Localize } from "../../app/lang/langs";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import ImageButton from "../../components/buttons/ImageButton";
import AddTeamsMembersModal from "./AddTeamsMembersModal";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { ConfirmModal } from "../../components/popups/ConfirmModal";
import userInfo from "../../assets/images/userInfo.png";
import userInfoFocus from "../../assets/images/userInfoFocus.png";
import { setCollabModalData } from "../../components/collabs/collabsSlice";
import { Col, Row } from "react-bootstrap";
import { InputSwitch } from "primereact/inputswitch";

export default function CollabsListModal(props) {

    const dispatch = useDispatch()
    const collabsList = useSelector((state) => state.clients.teamsCollabs)
    const allCollabs = useSelector((state) => state.collabs.allCollabsList)
    const [collabsListIds, setCollabsListIds] = useState([])
    const [addModalVisibility, setAddModalVisibility] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const [newDate, setNewDate] = useState(null)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const collabMissions = useSelector((state) => state.teams.collabMissions)
    const [onGoingMission, setOnGoingMission] = useState(false)
    const [showActiveOnly, setShowActiveOnly] = useState(true)

    useEffect(() => {
        const fetchMissions = async () => {
            if (selectedRow && selectedRow.id_collab) {
                await dispatch(getCollabMissions({ id_collab: selectedRow.id_collab }));
            }
        };

        fetchMissions();
    }, [selectedRow, dispatch]);

    useEffect(() => {
        if (collabMissions && collabMissions.ongoingMissions) {
            setOnGoingMission(collabMissions.ongoingMissions[0] || null);
        }
    }, [collabMissions]);

    useEffect(() => {
        if (props && props.visible && props.idTeam) {
            dispatch(getTeamCollabs({ id_team: props.idTeam }))
        } else {
            dispatch(setTeamsCollabs([]))
        }
    }, [props])

    useEffect(() => {
        setCollabsListIds(collabsList.map(collab => collab.id_collab));
    }, [collabsList])

    const handleDateChange = (rowData, date) => {
        setSelectedRow({ ...rowData });
        setNewDate(date);
        setShowConfirmModal(true);
    };

    const confirmDateChange = () => {
        if (selectedRow && newDate) {
            const updatedCollabsList = collabsList.map((collab) =>
                collab.id_collab === selectedRow.id_collab
                    ? { ...collab, end_date: newDate }
                    : collab
            );
            let ed = moment(newDate).format("YYYY-MM-DD HH:mm:ss")
            let sd = moment(selectedRow.start_date).format("YYYY-MM-DD HH:mm:ss")
            dispatch(editCollabMission({ id_collab: selectedRow.id_collab, start_date: sd, end_date: ed, id_mission: onGoingMission.id_mission }));

            dispatch(setTeamsCollabs([...updatedCollabsList]));
            setSelectedRow(null);
            setNewDate(null);
            setShowConfirmModal(false);
        }
    };

    const denyDateChange = () => {
        setSelectedRow(null);
        setNewDate(null);
        setShowConfirmModal(false);
    };

    const modalHeader = () => {
        return (
            <div>
                <Row>
                    {/*<Col md={1}>
                        <ImageButton
                            image={addIcon}
                            imageFocus={addIconFocus}
                            onClick={() => { setAddModalVisibility(true) }}
                            active={true}
                            tooltip={<Langs str="ADD_MEMBERS" />}
                            width={32} />
                    </Col>*/}
                    <Col className="align-content-center">
                        {props.teamName} ({collabsList.filter(collabsFilter).length})
                    </Col>
                    <Col md={2} className="d-flex justify-content-end align-content-center">
                        <InputSwitch className="ms-2 me-2"
                            tooltip={showActiveOnly ? Localize("Active collabs") : Localize("All collabs")}
                            tooltipOptions={{position: "left"}}
                            onChange={(e) => setShowActiveOnly(e.value)}
                            checked={showActiveOnly} />
                    </Col>
                </Row>
            </div>
        )
    }

    const viewCollabDetails = (rowData) => {
        return <ImageButton
            image={userInfo}
            imageFocus={userInfoFocus}
            onClick={() => viewCollabModal(rowData)}
            active={true}
            tooltip={<Langs str="VIEW_DETAILS" />}
            width={32} />
    }
    const viewCollabModal = (rowData) => {
        let collab = allCollabs.find(collab => collab.id === rowData.id_collab);
        const modalData = { ...collab, show: true };
        dispatch(setCollabModalData(modalData))
    }

    const collabsFilter = (collab) => {
        let now = moment()
        if (showActiveOnly && ((collab.start_date && now.isBefore(moment(collab.start_date))) || (collab.end_date && now.isAfter(moment(collab.end_date))))) {
            return false
        }
        return true
    }

    const onHide = () => {
        if (!props.visible) return
        if (props.setVisible) props.setVisible(false)
        setShowActiveOnly(true)
    }

    const startDateBody = (rowData) => {
        if (rowData.start_date) {
            let startDate = moment(rowData.start_date)
            let now = moment()
            return <label style={{ color: startDate.isAfter(now) ? "#008000": "black" }}>
                {startDate.format("DD/MM/YYYY")}
            </label>
        }
        return ""
    }

    const endDateBody = (rowData) => {
        if (rowData.end_date) {
            let endDate = moment(rowData.end_date)
            let now = moment()
            return <label style={{ color: endDate.isBefore(now) ? "#db5856" : "black" }}>
                {endDate.format("DD/MM/YYYY")}
            </label>
        }
        return <Calendar
            value={rowData.end_date}
            onChange={(e) => handleDateChange(rowData, e.value)}
            showIcon
            dateFormat="dd/mm/yy"
            placeholder="Select Date"
        />
    }

    return (
        <Dialog
            visible={props.visible}
            style={{ width: '60rem', height: "100vh", maxHeight: "100%", marginRight: 0 }}
            onHide={onHide}
            position="right"
            draggable={false}
            dismissableMask={true}
            header={modalHeader}
        >
            <DataTable value={collabsList.filter(collabsFilter)}
                scrollable
                scrollHeight="calc(85vh)"
                draggable={false}
            >
                <Column body={viewCollabDetails}></Column>
                <Column sortable field="prenom" header={<Langs str="prenom" />}></Column>
                <Column sortable field="nom" header={<Langs str="nom" />}></Column>
                <Column sortable field="email" header={<Langs str="email" />}></Column>
                <Column
                    sortable
                    field="start_date"
                    header={<Langs str="START_DATE" />}
                    body={startDateBody}
                />
                <Column
                    sortable
                    field="end_date"
                    header={<Langs str="END_DATE" />}
                    body={endDateBody}
                />
            </DataTable>
            <AddTeamsMembersModal
                visible={addModalVisibility}
                setVisible={setAddModalVisibility}
                prevCollabs={collabsListIds}
                idTeam={props.idTeam}
            />
            <ConfirmModal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                title="Confirmer la date"
                message="Voulez-vous vraiment définir cette date ?"
                onConfirm={confirmDateChange}
                onDeny={denyDateChange}
                confirmTitle="Confirmer"
                denyTitle="Annuler"
            />
        </Dialog>
    )
}